export const ReportsIcon = ({width='80', height='80', stroke='#A5A5A5'}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2532_66619)">
        <path
          d="M52.5 70.0002H17.5C16.837 70.0002 16.2011 69.7369 15.7322 69.268C15.2634 68.7992 15 68.1633 15 67.5002V22.5002C15 21.8372 15.2634 21.2013 15.7322 20.7325C16.2011 20.2636 16.837 20.0002 17.5 20.0002H42.5L55 32.5002V67.5002C55 68.1633 54.7366 68.7992 54.2678 69.268C53.7989 69.7369 53.163 70.0002 52.5 70.0002Z"
          stroke={stroke}
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M25 20.0002V12.5002C25 11.8372 25.2634 11.2013 25.7322 10.7325C26.2011 10.2636 26.837 10.0002 27.5 10.0002H52.5L65 22.5002V57.5002C65 58.1633 64.7366 58.7992 64.2678 59.268C63.7989 59.7369 63.163 60.0002 62.5 60.0002H55"
          stroke={stroke}
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M27.5 47.5002H42.5"
          stroke={stroke}
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M27.5 57.5002H42.5"
          stroke={stroke}
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2532_66619">
          <rect width={"80"} height="80" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
